@if(!showInvite) {
<div class="image-wrapper" *ngIf="image">
  <img class="img" src="{{image}}" />
</div>
}
@else {
<div class="image-wrapper-small" *ngIf="image">
  <img class="img" src="{{image}}" />
</div>
}
@if(showInvite) {
<app-invite-friend-screen [showInvite]="showInvite" [discounts]="discounts" expandWidth="true"></app-invite-friend-screen>
}
@if(!showInvite) {
<div class="information-screen-wrapper">
  <div class="information-screen-title">{{title}}</div>
  <div class="information-screen-primary-content">{{primaryContent}}</div>
  <div class="information-screen-secondary-content">{{secondaryContent}}</div>
</div>
<div class="info-screen-content">
  <ng-content></ng-content>
</div>
}
@else {
<div class="information-screen-wrapper">
  <div class="information-screen-title-small">{{title}}</div>
  <div class="information-screen-primary-content-small">{{primaryContent}}</div>
  <div class="information-screen-secondary-content-small">{{secondaryContent}}</div>
</div>
<div class="info-screen-content">
  <ng-content></ng-content>
</div>
}
